const StatisticalEvent = () =>
  import('@/views/main/live/statisticalEvent/StatisticalEvent.vue')
export default {
  path: '/main/live/statisticalEvent',
  name: 'LiveStatisticalEvent',
  component: StatisticalEvent,
  children: []
}
